export * from './format'
export * from './postForm'
export const loadPage = page => () => import(`@/page/${page}`)